module.exports = __webpack_public_path__ + "static/media/08.6dbcc8e9.jpg";